import angular from "../asset/icons/angularjs.png";
import css3 from "../asset/icons/css3.png";
import reacts from "../asset/icons/external-react-social-media-tanah-basah-glyph-tanah-basah.png";
import github from "../asset/icons/github.png";
import html5 from "../asset/icons/html-5.png";
import js from "../asset/icons/javascript-logo.png";
import redu from "../asset/icons/redux.png";
import sass from "../asset/icons/sass.png";
import image from "../asset/me.jpg";
import "./About.css";
function About() {
  return (
    <main className="container aboutComponent">
      <div className="row">
        <div className="col-md">
          <div className="layer">
          </div>
            <img src={image} alt="resume" className="profileImg"/>
        </div>
        <div className="col-md technology">
          <img src={html5} alt="" />
          <img src={css3} alt="" />
          <img src={js} alt="" />
          <img src={sass} alt="" />
          <img src={angular} alt="" />
          <img src={reacts} alt="" />
          <img src={redu} alt="" />
          <img src={github} alt="" />
        </div>
        <div className="about-me">
          <p>
            I came into the Web field because of the interest and the
            attractiveness of the Internet. I did my best to learn in depth
            client side language technology and implement standard with the
            right user experience,All the time I was trying to get to know the
            front-end so I could interact well with the back-end team as well as
            write the right code with scalability. Into all programming
            languages I've mention it and now with my knowledge and proficiency
            seeks a position in a leading organization in web designing and
            development to aid organizations to achieve their goals while
            seeking to develop my own skills and abilities
          </p>
        </div>
      </div>
    </main>
  );
}

export default About;
